/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Blank_Frames_Inserting_ToastInputs */

const en_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserting blank frames...`)
};

const fr_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion de frames vides...`)
};

const de_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Frames einfügen...`)
};

const it_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento di cornici vuote...`)
};

const ru_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка пустых рамок...`)
};

const es_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar marcos en blanco...`)
};

const zh_cn2_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入空白帧...`)
};

const ja_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白のフレームを挿入しています...`)
};

const hi_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डाले जा रहे हैं...`)
};

const pt_pt2_iframe_remote_blank_frames_inserting_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Inserting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserindo molduras em branco...`)
};

/**
* | output |
* | --- |
* | "Inserting blank frames..." |
*
* @param {Iframe_Remote_Blank_Frames_Inserting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_blank_frames_inserting_toast = /** @type {((inputs?: Iframe_Remote_Blank_Frames_Inserting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Blank_Frames_Inserting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "de") return de_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "it") return it_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "es") return es_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_blank_frames_inserting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_blank_frames_inserting_toast(inputs)
	return en_iframe_remote_blank_frames_inserting_toast(inputs)
});